<template>
  <div
    class="new-notif-prompt u-trans pa-3"
    :class="{ 'active': isShowed }"
  >
    <p class="font-weight-bold mb-2">{{ promptTitle }}</p>
    <p class="mb-2" v-html="latestTitle"></p>
    <!-- <div class="text-right">
      <button class="prompt-cancel u-trans mr-3" @click="isShowed = false">
        {{ t('common.noThanks') }}
      </button>
      <v-btn color="primary" @click="viewDetail">
        <span class="text-white text-normal">Chi tiết</span>
      </v-btn>
    </div> -->
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { ROUTE_PREFIX_PARAMS } from '@/utils/config';
import { api, nurse, customer } from '@/services';
import router from '@/router';

const authStore = useAuthStore();
const isShowed = ref(false);
const latestTitle = ref('');
const promptTitle = ref('');

async function fetchAndShow(isNew) {
  const services = authStore.mode === 'nurse' ? nurse : customer;

  const res = await api.get(
    `${services.messageList}?sort_desc=createdDate&limit=10&page=1`
  );

  const unread = res?.data?.list?.find(item => !item.hasRead);

  if (!unread) return;

  latestTitle.value = unread.title;
  promptTitle.value = isNew ? 'Thông báo mới' : 'Thông báo chưa đọc';

  isShowed.value = true;

  setTimeout(() => {
    isShowed.value = false;
  }, 3000);
}

onMounted(() => {
  if (authStore.haveNewMessages) fetchAndShow(false);
});

watch(
  () => authStore.haveNewMessages,
  (val, oldVal) => {
    if (val && !oldVal) fetchAndShow(true);
  }
);

const viewDetail = () => {
  isShowed.value = false;
  const prefix = authStore.mode === 'nurse' ? ROUTE_PREFIX_PARAMS.nurse : ROUTE_PREFIX_PARAMS.customer;
  router.push({ name: `${prefix}Notification` });
};
</script>

<style lang="scss" scoped>
.prompt-cancel {
  &:hover { color: var(--red); }
}
.new-notif-prompt {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  margin-inline: auto;
  width: 300px;
  font-size: 14px;
  background-color: white;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-110%);
  z-index: 900;
  border-radius: 4px;
  &.active {
    top: 10px;
    transform: translateY(0);
  }
}
</style>
